import * as React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import IconImage from 'src/assets/image/undraw_notify_rnwe 1.svg';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: 24,
    padding: theme.spacing(2),
    maxWidth: 600,
    width: '90%'
  },
  '& .MuiDialogContent-root': {
    padding: 0,
    overflow: 'visible'
  }
}));

interface DialogProps {
  onClose: () => void;
  open: boolean;
}

export default function UnSupportPage({ onClose, open }: DialogProps) {
  const navigate = useNavigate();
  const handleClose = () => {
    onClose();
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="unsupported-device-dialog"
        open={open}
      >
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              gap: 3
            }}
          >
            {/* Title */}
            <Typography
              variant="h4"
              textAlign={'left'}
              sx={{
                color: '#0088CC',
                fontWeight: 600,
                fontSize: { xs: '1.2rem', sm: '1.75rem' }
              }}
            >
              Your device is not supported
            </Typography>

            {/* Illustration */}
            <Box
              component="img"
              src={IconImage}
              alt="Device not supported"
              sx={{
                width: '100%',
                maxWidth: 400,
                height: 'auto',
                my: 2
              }}
            />

            {/* Warning Alert */}
            <Alert
              severity="warning"
              icon={false}
              sx={{
                width: '100%',
                backgroundColor: '#FFF9C4',
                color: '#F57C00',
                border: 'none',
                borderRadius: 2,
                fontSize: '1.1rem',
                fontWeight: 500,
                '& .MuiAlert-message': {
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2
                },
                py: 2,
                px: 3
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 2,
                  width: '100%'
                }}
              >
                <Box
                  sx={{
                    fontSize: '2rem',
                    lineHeight: 1,
                    flexShrink: 0
                  }}
                >
                  ⚠️
                </Box>
                <Box sx={{ textAlign: 'left' }}>
                  <Typography
                    sx={{
                      color: '#F57C00',
                      fontSize: '12px',
                      fontWeight: 500
                    }}
                  >
                    Your device is not supported.
                  </Typography>
                  <Typography
                    sx={{
                      color: '#F57C00',
                      fontSize: '12px',
                      fontWeight: 500
                    }}
                  >
                    Please continue on a desktop for the best experience.
                  </Typography>
                </Box>
              </Box>
            </Alert>
            <Button variant="contained" onClick={() => navigate(-1)}>
              Close
            </Button>
          </Box>
        </DialogContent>
      </BootstrapDialog>
    </React.Fragment>
  );
}
